<template>
  <span v-if="note" class="operation-price-basis" :title="metadata.tax_source_quote || note">
    <small v-if="metadata.tax_basis_label">{{ metadata.tax_basis_label }}</small>
    <small v-if="metadata.value_kind_label">{{ metadata.value_kind_label }}</small>
    <small v-if="metadata.comparison_label">{{ metadata.comparison_label }}</small>
  </span>
</template>
<script>
import { priceBasisNote } from '@/utils/operationPriceBasis.mjs';
export default {
  name: 'OperationPriceBasis',
  props: { metadata: { type: Object, default: () => ({}) } },
  computed: { note() { return priceBasisNote(this.metadata); } },
};
</script>
<style scoped>
.operation-price-basis { display:flex; justify-content:center; flex-wrap:wrap; gap:3px; margin-top:3px; line-height:1.4; }
.operation-price-basis small { font-size:10px; font-weight:normal; padding:1px 4px; border:1px solid var(--color-gray); border-radius:4px; opacity:.85; }
</style>
